import {
  addLineItems,
  checkout,
  getCart,
  getCartError,
  onBeforeCheckout,
  updateCart,
  updateLineItem,
  waitForSettle
} from '@/cart/cart-store'
import BuyStack17, { BuyStack17Props } from '@/components/buy-stack/bs-17/BuyStack17'
import QuantityInputData, { QuantityInputProps } from '@/components/buy-stack/bs-17/QuantityInput'
import { CartStore } from '@/components/buy-stack/bs-17/types'
import '@/components/buy-stack/TrialImageCarouselRegister'
import focus from '@alpinejs/focus'
import { effect } from '@preact/signals'
import Alpine from 'alpinejs'
import '@/components/buy-stack/pre-checkout-upsell-dialog/PreCheckoutUpsellDialog'

Alpine.plugin(focus)

const cartHandler: BuyStack17Props['cart'] = {
  getCart,
  getCartError,
  addLineItems,
  updateLineItem,
  checkout,
  updateCart,
  onBeforeCheckout,
  waitForSettle
}

Alpine.store('cartStore', { cart: getCart() })
effect(() => {
  const cartStore = Alpine.store('cartStore') as CartStore
  cartStore.cart = getCart()
  cartStore.error = getCartError()
})

Alpine.data(
  'buyStack17',
  (props: Pick<BuyStack17Props, 'step' | 'bundle' | 'bundles'>) =>
    new BuyStack17({ ...props, cart: cartHandler })
)

Alpine.data('quantityInput', (props: QuantityInputProps) => new QuantityInputData(props))

Alpine.start()
